import React, { useEffect } from 'react';
import Grid from '@mui/material/Grid';
import { useState } from "react";
import { Table, TableHead, TableBody, TableRow, TableCell } from '@mui/material';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { useParams } from 'react-router-dom';
import Button from '@mui/material/Button';
import { initialAndSearchStateSetter } from '../../Utility/InitialAndSearchStateSetter/InitialAndSearchStateSetter';
import { generateRandomString } from '../../Utility/GenerateRandomString/GenerateRandomString';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { mapStateToPropsForAllData } from '../../Utility/MapStateToPropsForAllData/MapStateToPropsForAllData';
import { useNavigate } from 'react-router-dom';
import { changeToReadableDate } from '../../Utility/ChangeToReadableDate/ChangeToReadableDate';

function Cases({ allDataOfContact, searchedDataOfContact }) {

  // sessionStorage.setItem("Pdsk21D34Rl98", false);

  const [isLoading, setIsLoading] = useState(true);
  const [casesData, setCasesData] = useState({});
  const navigate = useNavigate();
  const { searchedKeyword } = useParams();

  useEffect(() => {

    initialAndSearchStateSetter(searchedKeyword, searchedDataOfContact, navigate, setIsLoading, setCasesData, allDataOfContact);

  }, [allDataOfContact, searchedDataOfContact, isLoading, searchedKeyword]);

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <Grid container spacing={3}>
        <Box sx={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center'}}>
        <Typography
              component="h1"
              variant="h6"
              color="inherit"
              noWrap
              sx={{ flexGrow: 1, textAlign: 'left', marginLeft: 2, fontWeight: 'bold' }}
            >
              Cases
      </Typography>
      <Link to={`/CreateCase`} style={{ textDecoration: 'none', color: '#1976D2' }}>
      <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ width: "150px", height: "30px" }}
              onClick={() => { return "" }}
            >
              Add New Case
      </Button>
      </Link>
      </Box>

      { isLoading ? <Box sx={{ display: 'flex', width: '100%', justifyContent: 'center', alignItems: 'center', marginTop: '20px'  }}>
      <CircularProgress />
    </Box> : ((casesData?.data && casesData?.data?.Cases && casesData?.data?.Cases?.totalSize) != 0 ? <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 'bold' }}>Case Number</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>Subject</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>Status</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>Priority</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>Phone</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>Origin</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>Date/Time Opened</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
        {casesData?.data && casesData?.data?.Cases?.records?.map((caseData) => { 

          const caseIdOfContact = generateRandomString()+"00JZ3"+caseData.Id+generateRandomString();
          const finalReadableDate = changeToReadableDate(caseData.CreatedDate);

          return (
            <TableRow key={caseData.CaseNumber}>
              <TableCell><Link to={`/CaseDetail/${caseIdOfContact}`} style={{ textDecoration: 'none', color: '#1976D2' }}>{caseData.CaseNumber}</Link></TableCell>
              <TableCell>{caseData.Subject}</TableCell>
              <TableCell>{caseData.Status}</TableCell>
              <TableCell>{caseData.Priority}</TableCell>
              <TableCell>{caseData.ContactMobile}</TableCell>
              <TableCell>{caseData.Origin}</TableCell>
              <TableCell>{finalReadableDate}</TableCell>
            </TableRow>
          ) } )}
        </TableBody>
      </Table> : <div style={{ display: 'flex', width: '100%', justifyContent: 'center', alignItems: 'center', marginTop: '20px'}}><p>No Records Found!</p></div>)  }

        </Grid> 
  </Container>
  )
}

export default connect(mapStateToPropsForAllData)(Cases);